import Vue from "vue";
import VueRouter from "vue-router";
import store from '@/store/store'
Vue.use(VueRouter);

let routes = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: '*',
    component: () => import('@/pages/error/404.vue'),
    meta: {title: '页面错误'},
  },
  {
    name: "payPage",
    path: "/payPage",
    component: () => import('@/pages/payPage/payPage.vue'),
    meta: {
      title: '发起支付',
      showTab: false,
      goHome: true,
    }
  },
  {
    name: "autoPage",
    path: "/autoPage",
    component: () => import('@/pages/payPage/autoPage.vue'),
    meta: {
      title: '微信授权',
      showTab: false,
      goHome: true,
    }
  },

  // {
  //   name: "home", // 主页
  //   path: "/home",
  //   meta: {
  //     title: "芙蓉幸福教育",
  //     showTab: true,
  //   },
  //   component: () => import("@/pages/home.vue"),
  // },
  // {
  //   name: "loginCe", // 登录
  //   path: "/loginCe",
  //   meta: {
  //     title: "芙蓉幸福教育-登录界面",
  //     showTab: true,
  //   },
  //   component: () => import("@/pages/loginCe.vue"),
  // },
  // {
  //   name: "self", // 我的
  //   path: "/self",
  //   meta: {
  //     grade: 4,
  //     title: "我的",
  //     showTab: true,
  //   },
  //   component: () => import("@/pages/self.vue"),
  // },
]

// 自动扫描子模块路由并导入,根据不同的业务模块进行拆分路由
const routerContext = require.context('./', true, /index\.js$/)
routerContext.keys().forEach(route => {
  // 如果是根目录的 index.js 、不处理
  if (route.startsWith('./index')) {
    return
  }
  const routerModule = routerContext(route)
  // 兼容 import export 和 require module.export 两种规范
  routes = [...routes, ...(routerModule.default || routerModule)]
})
const router = new VueRouter({
  base: process.env.BASE_URL,
  mode: 'history',
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  // if(to.path==="/notes"){
  //   console.log(to)
  //   next({path:'/uploadCard',query:to.query})
  //   return
  // }
  next()
  // if ( true ||store.state.user.isLogin) {
  //   next()
  // } else {
  //   if (to.path === '/login') {
  //     next()
  //   } else {
  //     next('/login')
  //   }
  // }
})

//重写 router push 方法 避免重复点击报错问题
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

// 重写 router replace 方法 避免重复点击报错问题
const VueRouterReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(to) {
  return VueRouterReplace.call(this, to).catch(err => err)
}

export default router;
